module.exports = __webpack_public_path__ + "img/cover_bg.c06ec580.png";